const KEY = 'inviteTokens';

type InviteToken = {
  inviteToken: string;
  message: string;
};

export const setInviteToken = (inviteToken: string) => {
  const tokens = localStorage.getItem(KEY);

  if (!tokens) {
    localStorage.setItem(KEY, JSON.stringify([{ inviteToken, message: '' }]));
  } else {
    const tokensArray = JSON.parse(tokens) as InviteToken[];
    const isTokenExisted = !!tokensArray.find(
      (token) => token.inviteToken === inviteToken,
    );

    if (!isTokenExisted) {
      tokensArray.push({ inviteToken, message: '' });
      localStorage.setItem(KEY, JSON.stringify(tokensArray));
    }
  }
};

export const getCurrentInviteToken = (): InviteToken | null => {
  const tokens = localStorage.getItem(KEY);

  if (tokens) {
    const tokensArray = JSON.parse(tokens) as InviteToken[];

    return tokensArray[tokensArray.length - 1] || null;
  }

  return null;
};

export const getAllInviteTokens = (): InviteToken[] => {
  const tokens = localStorage.getItem(KEY);

  if (tokens) {
    const tokensArray = JSON.parse(tokens) as InviteToken[];

    return tokensArray;
  }

  return [];
};

export const updateCurrentInviteTokenWithMessage = (message: string) => {
  const tokens = localStorage.getItem(KEY);

  if (tokens) {
    const tokensArray = JSON.parse(tokens) as InviteToken[];
    let lastItem = tokensArray.pop();

    if (lastItem) {
      lastItem = { ...lastItem, message };
      localStorage.setItem(KEY, JSON.stringify([...tokensArray, lastItem]));
    }
  }
};

export const deleteInviteToken = (tokenTobeDeleted?: string) => {
  const tokens = localStorage.getItem(KEY);

  if (tokens) {
    const tokensArray = JSON.parse(tokens) as InviteToken[];

    if (tokenTobeDeleted) {
      localStorage.setItem(
        KEY,
        JSON.stringify(
          tokensArray.filter((t) => t.inviteToken !== tokenTobeDeleted),
        ),
      );
    } else {
      tokensArray.pop();
      localStorage.setItem(KEY, JSON.stringify(tokensArray));
    }
  }
};

export const deleteAllTokens = () => {
  localStorage.setItem(KEY, JSON.stringify([]));
};
